import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getOutstandingBalance = async (studentId: string) => {
  const response = await baseAPI.get<{ totalOutstanding: string }>(
    `/students/${studentId}/outstanding-balance`,
  );
  return response.data;
};

export const useGetOutstandingBalance = (studentId: string) => {
  return useQuery({
    queryKey: [KEYS.OUTSTANDING_BALANCE, studentId],
    queryFn: () => getOutstandingBalance(studentId),
  });
};
